import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../context/AuthContext';
import { apiFetch, extractArray } from '../lib/api';

/**
 * Shared cached hook for CRM contacts.
 * Stays fresh for 5 minutes, cached for 10 minutes after unmount.
 * Any page that needs contacts (Inbox, Contacts, ContactEmailTypeahead, etc.)
 * gets instant data after the first load.
 */
export function useContacts(options = {}) {
    const { getAuthHeader } = useAuth();
    const { pageSize = 500, enabled = true } = options;

    return useQuery({
        queryKey: ['contacts', { pageSize }],
        queryFn: async () => {
            const data = await apiFetch(`/contacts?page_size=${pageSize}`, getAuthHeader());
            return extractArray(data);
        },
        staleTime: 5 * 60 * 1000,  // 5 min
        enabled,
    });
}

export default useContacts;
